export const TASK_LIST_PAGE_SIZE = 20;

export const parsePageParam = (raw) => {
  if (raw == null || raw === "") return 1;
  const text = String(raw);
  if (!/^[1-9]\d*$/.test(text)) return 1;
  const numeric = Number(text);
  if (!Number.isSafeInteger(numeric) || numeric <= 0) return 1;
  return numeric;
};

export const parsePositiveId = (raw) => {
  if (raw == null || raw === "") return null;
  const text = String(raw);
  if (!/^[1-9]\d*$/.test(text)) return null;
  const numeric = Number(text);
  if (!Number.isSafeInteger(numeric) || numeric <= 0) return null;
  return numeric;
};
